import { StatelessApp } from '@katalon-studio/katalon-ui-utils';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import {
  fromAuth, fromLayout,
  useAppDispatch,
} from '../../../store';
import { useLaunchDarkly } from '../../../launchdarkly';
import { checkAndRenewToken } from '../../../services/keycloak';
import { usePermission } from '../../../permission';
import { useQuery, useReadOnlyMode } from '../../../routes';

const SubscriptionManagementPage = () => {
  const dispatch = useAppDispatch();
  const { get } = useQuery();
  const { flags } = useLaunchDarkly();
  const token = useSelector(fromAuth.selectToken);
  const { permissionMapping } = usePermission();
  const accountId = Number(get('accountId'));
  const path = `${window.location.origin}/${process.env.REACT_APP_SUBSCRIPTIONS_MANAGEMENT_MICROAPP_URL}/index.html?t=${new Date().getTime()}`;
  const isReadOnly = useReadOnlyMode();

  useEffect(() => {
    dispatch(fromLayout.setLoading(false));
  }, []);

  return (
    <StatelessApp
      id="katalon-subscription-management"
      key={`katalon-subscription-management-${accountId}`}
      path={path}
      context={{
        config: {
          ceBaseUrl: `${window.location.origin}`,
          ceApiUrl: `${process.env.REACT_APP_API_URL}`,
          k1ApiUrl: `${process.env.REACT_APP_K1_API_URL}`,
          adminUrl: `${process.env.REACT_APP_ADMIN_URL}`,
          g3Url: `${process.env.REACT_APP_TESTOPS_G3_URL}`,
          accessToken: token?.jwt,
          getNewAccessToken: checkAndRenewToken,
          stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
          isReadOnly,
        },
        ldFlags: flags,
        permissions: permissionMapping,
      }}
    />
  );
};

export default SubscriptionManagementPage;
